import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faBars,
  faCar,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faClock,
  faEdit,
  faFilter,
  faGift,
  faMinus,
  faPlus,
  faSearch,
  faSearchPlus,
  faSortAmountDownAlt,
  faSync,
  faTimes,
  faTruck,
  faUndo,
  faCookieBite,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faClone, faTimesCircle, faUserCircle } from '@fortawesome/free-regular-svg-icons';

library.add(
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faBars,
  faCar,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faClock,
  faEdit,
  faFilter,
  faGift,
  faMinus,
  faPlus,
  faSearch,
  faSearchPlus,
  faSortAmountDownAlt,
  faSync,
  faTimes,
  faTimesCircle,
  faTruck,
  faUndo,
  faCookieBite,
);
library.add(faUserCircle, faClone);

Vue.component('fa-icon', FontAwesomeIcon);
